import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "row-justify"
};
const _hoisted_2 = {
  class: "row-justify"
};
const _hoisted_3 = {
  class: "cell-card-header"
};
import { computed, onMounted, reactive, ref, watch } from 'vue';
import CellCard from './components/CellCard.vue';
import LabelValue from './components/LabelValue.vue';
import ChartPie from './components/ChartPie.vue';
// import ChartLine from './components/ChartLine.vue'
import ChartBar from './components/ChartBar.vue';
import { queryStorageAssets, querySmsDemandAuditStats } from '@/api/modules/dataCenter';
import { useSmsAuditStats } from './hooks/useSmsAuditStats';

/** 素材按类型统计 */

export default {
  __name: 'Index',
  setup(__props) {
    const assetsType = reactive([]);
    /** 素材按生效统计 */
    const assetsValid = reactive([]);
    /** 素材总数 */
    const assetsValidSum = computed(() => {
      let sum = 0;
      assetsValid.forEach(e => {
        sum += e.value;
      });
      return sum;
    });

    // 加载素材总体统计信息
    function loadStorageAssets() {
      queryStorageAssets('assetsType').then(res => {
        if (!res.data || !res.data.length) {
          return;
        }
        res.data.forEach(e => {
          assetsType.push({
            value: e.cnt,
            name: e.title
          });
        });
      });
      queryStorageAssets('assetsValid').then(res => {
        if (!res.data || !res.data.length) {
          return;
        }
        res.data.forEach(e => {
          assetsValid.push({
            value: e.cnt,
            name: e.title
          });
        });
      });
    }
    onMounted(() => {
      loadStorageAssets();
    });

    // const smsAuditStats
    // 短信需求审核状态统计
    const smsAuditStates = [{
      label: '待审核',
      id: 2
    }, {
      label: '审核通过',
      id: 3
    }, {
      id: 6,
      label: '审核驳回'
    }];
    const selectedSmsAuditStateId = ref(3);
    const {
      smsAuditStats
    } = useSmsAuditStats(selectedSmsAuditStateId);
    const smsAuditStatsChart = computed(() => {
      const xAxis = [];
      /** 集客 */
      const seriesJK = {
        name: '集客',
        type: 'bar',
        data: []
      };
      /** 市场 */
      const seriesSC = {
        name: '市场部',
        type: 'bar',
        data: []
      };
      smsAuditStats.value.forEach(e => {
        if (!e.month) {
          return;
        }
        xAxis.push(e.month);
        seriesJK.data.push(e.jike || 0);
        seriesSC.data.push(e.shichang || 0);
      });
      return {
        xAxis,
        series: [seriesJK, seriesSC]
      };
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 18
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12,
              class: "group"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(CellCard, {
                  title: "素材类型统计"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assetsType, (item, index) => {
                    return _openBlock(), _createBlock(LabelValue, {
                      key: index,
                      label: item.name,
                      value: item.value
                    }, null, 8, ["label", "value"]);
                  }), 128))])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(CellCard, {
                  title: "素材类型占比"
                }, {
                  default: _withCtx(() => [_createVNode(ChartPie, {
                    height: "350px",
                    width: "100%",
                    data: assetsType
                  }, null, 8, ["data"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12,
              class: "group"
            }, {
              default: _withCtx(() => [_createVNode(CellCard, {
                title: "素材生效情况"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assetsValid, (item, index) => {
                  return _openBlock(), _createBlock(LabelValue, {
                    key: index,
                    label: item.name,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128)), _createVNode(LabelValue, {
                  label: "素材总数量",
                  value: assetsValidSum.value
                }, null, 8, ["value"])]), _cache[1] || (_cache[1] = _createElementVNode("div", {
                  style: {
                    height: '40px'
                  }
                }, null, -1)), _createVNode(ChartPie, {
                  height: "350px",
                  width: "100%",
                  data: assetsValid
                }, null, 8, ["data"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "group"
          }, {
            default: _withCtx(() => [_createVNode(CellCard, {
              title: "短信需求审核统计"
            }, {
              header: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_select, {
                modelValue: selectedSmsAuditStateId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedSmsAuditStateId.value = $event),
                class: "m-2",
                size: "small"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(smsAuditStates, item => {
                  return _createVNode(_component_el_option, {
                    key: item.id,
                    label: item.label,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])])]),
              default: _withCtx(() => [_createVNode(ChartBar, {
                height: "300px",
                width: "100%",
                "x-axis": smsAuditStatsChart.value.xAxis,
                series: smsAuditStatsChart.value.series
              }, null, 8, ["x-axis", "series"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(CellCard, {
              title: ""
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};